export default "__VITE_ASSET__fcd416dc__"